const BOOKMARK_KEY = 'k_tourspot_bookmarks';
const RECENT_KEY = 'k_tourspot_recent';

export function getBookmarks() {
  try {
    const raw = localStorage.getItem(BOOKMARK_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function isBookmarked(id) {
  const bookmarks = getBookmarks();
  return bookmarks.includes(id);
}

export function toggleBookmark(id) {
  let bookmarks = getBookmarks();
  if (bookmarks.includes(id)) {
    bookmarks = bookmarks.filter(bId => bId !== id);
  } else {
    bookmarks.push(id);
  }
  localStorage.setItem(BOOKMARK_KEY, JSON.stringify(bookmarks));
  return bookmarks.includes(id);
}

export function addRecentView(id) {
  try {
    let recents = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    recents = [id, ...recents.filter(item => item !== id)].slice(0, 20);
    localStorage.setItem(RECENT_KEY, JSON.stringify(recents));
  } catch {}
}

export function calculateDistance(lat1, lon1, lat2, lon2) {
  if (!lat1 || !lon1 || !lat2 || !lon2) return null;
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return Math.round(d * 10) / 10;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function getOperatingStatus(center) {
  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const isSummer = currentMonth >= 4 && currentMonth <= 10;

  const openTimeStr = isSummer ? (center.summerOpen || '09:00') : (center.winterOpen || '09:00');
  const closeTimeStr = isSummer ? (center.summerClose || '18:00') : (center.winterClose || '18:00');

  // Check if closed day matches today
  const dayNames = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
  const todayName = dayNames[now.getDay()];
  const closedDays = center.closedDays || '';

  if (closedDays.includes(todayName) || closedDays.includes('매주 ' + todayName.slice(0, 1))) {
    return { status: 'holiday', textKey: 'statusHoliday', hours: `${openTimeStr} ~ ${closeTimeStr}` };
  }

  // Parse time
  const [openH, openM] = openTimeStr.split(':').map(Number);
  const [closeH, closeM] = closeTimeStr.split(':').map(Number);

  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const openMinutes = (openH || 9) * 60 + (openM || 0);
  const closeMinutes = (closeH || 18) * 60 + (closeM || 0);

  if (currentMinutes >= openMinutes && currentMinutes <= closeMinutes) {
    return { status: 'open', textKey: 'statusOpen', hours: `${openTimeStr} ~ ${closeTimeStr}` };
  } else {
    return { status: 'closed', textKey: 'statusClosed', hours: `${openTimeStr} ~ ${closeTimeStr}` };
  }
}
